export default __webpack_public_path__ + "83bcc4eddf87d7e7b226e44f7bbe6843.png";